import styled from 'styled-components';

export const PlusIconWrapper = styled.span`
  height: 24px;
  svg {
    height: 100%;
    fill: currentColor;
  }
`;
